import { PresentationApiClient } from "./http-api-client";

export const getPartialCmaPresentationApiClient = () => {
  return new PresentationApiClient();
};
